
//Libraries
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  name: "ShopGame",
  setup() {
    //Data
    const isLoading = ref<boolean>(true);

    //Lifecycle Hooks

    onMounted(() => {
      setTimeout(() => {
        isLoading.value = false;
      }, 600);
    });

    return {
      isLoading,
    };
  },
});
